















































































import { Vue, Component } from "vue-property-decorator";
import * as auth from "../_store/auth.module";
import * as user from "../_store/user.module";
import ChangePassword from "../components/ChangePassword.vue";
import { bus } from "../main"

@Component({
  components: {
    ChangePassword
  }
})
export default class Login extends Vue {
  username: string = "";
  password: string = "";
  show: boolean = false;
  loading: boolean = false;

  //methods
  reset(): void {
    this.username = "";
    this.password = "";
  }

  onSignIn(): void {
    if (this.password && this.username) {
      this.loading = true
      var payload = {
        username: this.username,
        password: this.password
      };
      auth.dispatchLogin(this["$store"], payload)
      .catch(error =>{
         this.loading = false
      })
    }
  }

  created(){
    auth.dispatchLogout(this["$store"])
    user.dispatchClearState(this["$store"]);
  }
}
